<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.purchaserequisition') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status == 'padding'"
                    class="badge badge-warning">{{ $t('status.po.padding') }}</span>
                  <span
                    v-if="query.status == 'rejected'"
                    class="badge badge-danger">{{ $t('status.po.rejected') }}</span>
                  <span
                    v-if="query.status == 'uncompleted'"
                    class="badge badge-info">{{ $t('status.po.uncompleted') }}</span>
                  <span
                    v-if="query.status == 'completed'"
                    class="badge badge-success">{{ $t('status.po.completed') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-warning"
                        value="padding">
                        {{ $t('status.pr.padding') }}
                      </option>
                      <option
                        class="text-danger"
                        value="rejected">
                        {{ $t('status.pr.rejected') }} / {{ $t('status.po.rejected') }}
                      </option>
                      <option
                        class="text-info"
                        value="wait_for_po">
                        {{ $t('status.pr.wait_for_po') }}
                      </option>
                      <option
                        class="text-info"
                        value="uncompleted">
                        {{ $t('status.po.uncompleted') }}
                      </option>
                      <option
                        class="text-success"
                        value="completed">
                        {{ $t('status.pr.completed') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.po') }}</th>
              <th class="no-sort">{{ $t('message.vendor') }}</th>
              <th class="no-sort">{{ $t('message.productlist') }}</th>
              <th class="no-sort">{{ $t('documents.po') }}</th>
              <th>{{ $t('message.scheduled_at') }}</th>
              <th
                class="no-sort"
                style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="purchases.length === 0"
                colspan="10"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in purchases"
              :key="index">
              <td :data-order="item.po_id">
                <router-link-custom
                  :to="{name: 'PurchaseRequisitionEdit', query: {
                    id: item.po_id,
                    code: item.po_code
                  }}"
                  :text="item.po_code"
                  :to_appid="4"
                  :current_appid="4"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.vendor"
                  :to="{name: 'ContactVendorEdit', query: {ven_id: item.vendor.vendor_id, ven_name: item.vendor.vendor_name}}"
                  :text="item.vendor.vendor_name"
                  :to_appid="11"
                  :current_appid="4"
                  :disabled="item.vendor.is_deleted == true" />
              </td>
              <td style="vertical-align: top;">
                <item-list :orders="item.orders" />
              </td>
              <td style="vertical-align: top;">
                <div
                  v-for="(purchase, index_) in item.reference.purchase_orders"
                  :key="index_">
                  <router-link-custom
                    :to="{name: 'PurchaseOrderEdit', query: {
                      id: purchase.po_id,
                      code: purchase.po_code,
                    }}"
                    :text="purchase.po_code"
                    :status="{
                      text: getPurchaseStatus(purchase, $t, mixin).message,
                      color: getColorFormStatus(getPurchaseStatus(purchase, $t, mixin).status),
                      type: 'icon'
                    }"
                    :to_appid="4"
                    :current_appid="4"/>
                </div>
              </td>
              <td :data-order="item.scheduled_at">
                {{ getDate(item.scheduled_at) }}
              </td>
              <td style="max-width: 100px;">
                <template>
                  <span
                    v-if="getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getPRStatus(item, item.reference.purchase_orders.length ? item.reference.purchase_orders[0] : null, $t, mixin).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      purchases: 'getPurchases',
      getPurchaseStatus: 'getPurchaseStatus',
      getPaymentStatus: 'getPaymentStatus',
      getGoodsReceiptStatus: 'getGoodsReceiptStatus',
      getPRStatus: 'getPRStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.purchases.title'),
      current: {
        app_name: 'purchases',
        app_id: 4,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPurchases'])
  },
  methods: {
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getPurchases', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
        doc_type: 'pr',
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/pr/All.vue